import React from 'react';
import './About.css';
import Page from './Page.js';

const About = () => {
  return <>
  <section>
      <div class="nes-balloon from-right">
        <p>
          Hello! I am Eren Yenigul. I am studying Computer Engineering & Mathematics at Koc University. You can reach me from the following links below.
        </p>
      </div>
      <img src="https://avatars.githubusercontent.com/u/30075886?v=4" alt="Eren Yenigül" className="nes-avatar my-photo" />

    </section>
 
    <div className="social">
      <a href="https://github.com/erenyenigul" alt="My github page"> <i class="nes-icon github is-medium"></i><span>Github</span></a>
      <a href="https://www.linkedin.com/in/eren-yenig%C3%BCl-662a0a203/" alt="My linkedin page"><i class="nes-icon linkedin is-medium"></i><span>Linkedin</span></a>
      <a href="mailto:erenyenigul@gmail.com"><i class="nes-icon gmail is-medium"></i><span>erenyenigul@gmail.com</span></a>
    </div>
    </>;
};

export default About;
